import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import FaqsContent from './FaqsContent'
export default class Faqs extends Component {

    render() {

        let page = this.props.match.params.page;

        const urlParams = new URLSearchParams(window.location.search);

        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <FaqsContent urlParams={urlParams} page={page} />
                <Footer />

            </div>


        )
    }
}
